/* entry: product */

import './product.scss';

// Modules
import Accordion from '@thorborn/accordion';
import '@thorborn/accordion/src/styles.scss';
import EngravingSelector from '../../../core/modules/engraving-selector/engraving-selector';

// Snippets
import '../../snippets/accordion/accordion';
import '../../snippets/engraving-item/engraving-item';
import '../../snippets/engraving-selector/engraving-selector';
import '../../snippets/product-form/product-form';
import '../../snippets/shipping-notification/shipping-notification';

(() => {
  const productAccordionEl = document.querySelector(
    '.Accordion.ProductAccordion',
  );

  if (productAccordionEl) {
    // eslint-disable-next-line no-unused-vars
    const productAccordion = new Accordion('.Accordion.ProductAccordion', {
      transitionDuration: 300,
      disableScrollIntoView: true,
    });
  }

  const engravingSelectorEls = document.querySelectorAll('.EngravingSelector');

  engravingSelectorEls.forEach((engravingSelectorEl) => {
    // eslint-disable-next-line no-unused-vars
    const engravingSelector = new EngravingSelector(engravingSelectorEl);
  });
})();
